import classNames from 'classnames';
import './Tabs.scss';
import { useTabs } from '../../hooks';
import { useTranslation } from 'react-i18next';

interface Props<T> {
  tabs: T[];
  initialTab?: T;
  renderContent: (id: T) => JSX.Element;
}

export default function Tabs<T>({ tabs, initialTab, renderContent }: Props<T>) {
  const { t } = useTranslation();
  const { activeTab, onClickTab } = useTabs(initialTab || tabs[0]);

  return (
    <div className='d-flex flex-column'>
      <div className='Tabs__nav row row-cols-auto mx-0 mb-3 pb-1'>
        {tabs.map((tab) => (
          <div
            className='col d-flex align-items-center'
            key={tab as string | number}
          >
            <button
              className={classNames('Tabs__tab position-relative pb-2', {
                'Tabs__tab--active': activeTab === tab,
              })}
              onClick={onClickTab(tab)}
            >
              {typeof tab === 'string' ? t(tab) : tab}
            </button>
          </div>
        ))}
      </div>
      <div className='flex-grow-1'>{renderContent(activeTab)}</div>
    </div>
  );
}
